export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/30"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="w-full mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 mb-5 text-xs md:text-sm font-medium text-primary-700 bg-primary-100/80 rounded-full whitespace-nowrap">
              📣 热门韩漫 · 日漫 · 国漫 — 全部免费全集
            </span>

            <h1 className="font-heading font-black text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight mb-4">
              羞羞羞漫画
              <span className="block text-primary-600 mt-1">免费全集下拉式阅读平台</span>
            </h1>

            <p className="font-heading text-base md:text-lg text-foreground-600 mb-6 font-medium">
              告别翻页，一滑到底 · 热门韩漫日漫国漫，每日同步追更
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-2xl mx-auto lg:mx-0">
              羞羞漫画是国内领先的免费漫画在线阅读平台，汇聚韩国、日本及国内数千部热门漫画作品。
              我们独创下拉式阅读模式，让你像刷朋友圈一样流畅阅读，单手操作轻松自在。
              平台每日同步更新，海量完结全集免费开放，无需付费、无需会员，
              为漫画爱好者提供极致的高清免费阅读体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">12,000+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">漫画作品</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-600">每日更新</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">同步追更</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-secondary-600">100%免费</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">零门槛阅读</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                立即开始阅读
              </a>
              <a
                href="#cards"
                onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-8 py-3.5 bg-background-50 text-foreground-800 font-medium text-sm rounded-lg border border-background-300 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                精选推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/5] max-w-md mx-auto lg:max-w-none rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%2C%20romantic%20fantasy%20couple%20scene%2C%20male%20and%20female%20characters%20in%20elegant%20attire%2C%20soft%20warm%20lighting%20with%20magical%20sparkles%2C%20ethereal%20dreamy%20atmosphere%2C%20delicate%20pastel%20and%20coral%20tones%2C%20beautiful%20composition%20with%20flowing%20hair%20and%20fabric&width=600&height=750&seq=hero-main-visual&orientation=portrait"
                alt="羞羞漫画 - 热门漫画推荐"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <span className="inline-block px-3 py-1 bg-background-50/90 text-xs font-medium text-primary-700 rounded-full whitespace-nowrap">
                  🔥 今日热门推荐
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}